import { fromJS } from 'immutable';
import * as actions from '../actions/eventform';
import { fetchingState } from '@constants';

const initialStats = {
  eventFormList: {},
  eventForm: {},
  dataObjects: {},
  eventGroups: {},
  formTags: {},
  publishedTypes: {},
  unPublishedTypes: {}
};

const sortFormFields = eventForm =>
  Object.assign({}, eventForm, {
    formFields: eventForm.formFields.sort(
      (formField1, formField2) => formField1.order - formField2.order,
    ),
  });

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.EVENT_FORMS_FETCH_START:
    case actions.ECONOMIC_UNITS_EVENT_FORMS_FETCH_START:
    case actions.PROPERTY_EVENT_FORMS_FETCH_START:
    case actions.OWNER_EVENT_FORMS_FETCH_START: {
      return state.setIn(['eventFormList', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_FORMS_FETCH_SUCCESS:
    case actions.ECONOMIC_UNITS_EVENT_FORMS_FETCH_SUCCESS:
    case actions.PROPERTY_EVENT_FORMS_FETCH_SUCCESS:
    case actions.OWNER_EVENT_FORMS_FETCH_SUCCESS: {
      return state
        .setIn(['eventFormList', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventFormList', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.EVENT_FORMS_FETCH_ERROR:
    case actions.ECONOMIC_UNITS_EVENT_FORMS_FETCH_ERROR:
    case actions.PROPERTY_EVENT_FORMS_FETCH_ERROR:
    case actions.OWNER_EVENT_FORMS_FETCH_ERROR: {
      return state.setIn(['eventFormList', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_FORM_DELETE_SUCCESS: {
      return state.setIn(
        ['eventFormList', 'data'],
        fromJS(
          state
            .getIn(['eventFormList', 'data'])
            .toJS()
            .filter(eventForm => eventForm.formID !== action.formID),
        ),
      );
    }

    case actions.EVENT_FORM_DUPLICATE_SUCCESS: {
      return state.setIn(
        ['eventFormList', 'data'],
        fromJS(
          state
            .getIn(['eventFormList', 'data'])
            .toJS()
            .concat(action.data ? action.data.results : []),
        ),
      );
    }

    case actions.EVENT_FORM_CREATE_START: {
      return state.setIn(['eventForm', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_FORM_CREATE_SUCCESS: {
      return state
        .setIn(['eventForm', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventForm', 'data'],
          fromJS(sortFormFields(action.data.results[0])),
        );
    }
    case actions.EVENT_FORM_CREATE_ERROR: {
      return state.setIn(['eventForm', 'state'], fetchingState.LOADED);
    }

    case actions.DATA_OBJECTS_FETCH_START: {
      return state.setIn(['dataObjects', 'state'], fetchingState.FETCHING);
    }
    case actions.DATA_OBJECTS_FETCH_SUCCESS: {
      return state
        .setIn(['dataObjects', 'state'], fetchingState.LOADED)
        .setIn(
          ['dataObjects', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.DATA_OBJECTS_FETCH_ERROR: {
      return state.setIn(['dataObjects', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_GROUPS_FETCH_START: {
      return state.setIn(['eventGroups', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_GROUPS_FETCH_SUCCESS: {
      return state
        .setIn(['eventGroups', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventGroups', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.EVENT_GROUPS_FETCH_ERROR: {
      return state.setIn(['eventGroups', 'state'], fetchingState.ERROR);
    }

    case actions.RESET_EVENT_FORM: {
      return state.setIn(['eventForm'], fromJS({}));
    }

    case actions.EVENT_FORM_FETCH_START: {
      return state.setIn(['eventForm', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_FORM_FETCH_SUCCESS: {
      return state
        .setIn(['eventForm', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventForm', 'data'],
          fromJS(sortFormFields(action.data.results[0])),
        );
    }
    case actions.EVENT_FORM_FETCH_ERROR: {
      return state.setIn(['eventForm', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_FORM_UPDATE_START: {
      return state.setIn(['eventForm', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_FORM_UPDATE_SUCCESS: {
      return state
        .setIn(['eventForm', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventForm', 'data'],
          fromJS(sortFormFields(action.data.results[0])),
        );
    }
    case actions.EVENT_FORM_UPDATE_ERROR: {
      return state.setIn(['eventForm', 'state'], fetchingState.LOADED);
    }

    case actions.EVENT_TYPES_UPDATE_SUCCESS: {
      return state.setIn(
        ['eventForm', 'data'],
        fromJS(sortFormFields(action.data.results[1])),
      );
    }

    case actions.FORM_FIELDS_UPDATE_START: {
      return state.setIn(['eventForm', 'state'], fetchingState.SAVING);
    }
    case actions.FORM_FIELDS_UPDATE_SUCCESS: {
      return state
        .setIn(['eventForm', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventForm', 'data'],
          fromJS(sortFormFields(action.data.results[0])),
        );
    }
    case actions.FORM_FIELDS_UPDATE_ERROR: {
      return state.setIn(['eventForm', 'state'], fetchingState.LOADED);
    }

    case actions.FORM_TAGS_FETCH_START: {
      return state.setIn(['formTags', 'state'], fetchingState.FETCHING);
    }
    case actions.FORM_TAGS_FETCH_SUCCESS: {
      return state
        .setIn(['formTags', 'state'], fetchingState.LOADED)
        .setIn(
          ['formTags', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FORM_TAGS_FETCH_ERROR: {
      return state.setIn(['formTags', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_FORM_PUBLISHED_TYPES_START: {
      return state.setIn(['publishedTypes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_FORM_PUBLISHED_TYPES_SUCCESS: {
      return state
        .setIn(['publishedTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['publishedTypes', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_FORM_PUBLISHED_TYPES_ERROR: {
      return state.setIn(['publishedTypes', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_FORM_UNPUBLISHED_TYPES_START: {
      return state.setIn(['unPublishedTypes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_FORM_UNPUBLISHED_TYPES_SUCCESS: {
      return state
        .setIn(['unPublishedTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['unPublishedTypes', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_FORM_UNPUBLISHED_TYPES_ERROR: {
      return state.setIn(['unPublishedTypes', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
